import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

const useDevicesByEmail = (email) => {
    const [userDeviceList, setUserDeviceList] = useState([]);

    const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/bms/my-devices?email=${email}`;
    const { data: userDevices, isLoading, refetch } = useQuery('userDevices', () => fetch(url)
        .then(res => res.json()));

    useEffect(() => {
        if (userDevices) {
            setUserDeviceList(userDevices.data);
        }
    }, [userDevices]);

    return [userDeviceList, isLoading, refetch];
};

export default useDevicesByEmail;